// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goal-task-steps-popup__container[data-v-7d49ca0d]{max-height:70vh;overflow-y:auto;overflow-x:hidden}.goal-task-steps-popup__step-fields__description-link__container[data-v-7d49ca0d]{min-height:13px;width:100%;display:inline-block}\n", ""]);
// Exports
module.exports = exports;
